// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__D6Dv8","img":"Image_img__02+6z","skeleton":"Image_skeleton__wmk6j"};